import React, { Component } from "react";
import { withRouterUtilities } from "../util/withRouterUtilities";
import CenteredPaper from "../layouts/CenteredPaper";
import ChoiceButtons from "../molecules/ChoiceButtons";
import Titles from "../molecules/Titles";
import ILearn from "../molecules/ILearn";

class IrqNotSupportedView extends Component {
  render() {
    return (
      <ILearn content={this.props.content}>
        <CenteredPaper>
          <Titles content={this.props.content} />
          <ChoiceButtons
            content={this.props.content}
            navigationsAway={this.props.navigationsAway}
          />
        </CenteredPaper>
      </ILearn>
    );
  }
}

export default withRouterUtilities(IrqNotSupportedView);
